import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import { isSubdomainAndSkill } from 'bundles/browse-common/utils/domain-utils';
import { isBrowseSkillsEnabled } from 'bundles/browse-common/utils/epicUtils';
import BrowseApp from 'bundles/browse/components/BrowseApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const DomainPage = loadOnRoute(() => import('bundles/browse/components/Domain/DomainPage'));
const AllDomainV2Page = loadOnRoute(() => import('bundles/browse/v2/pages/AllDomainV2Page'));
const DomainV2Page = loadOnRoute(() => import('bundles/browse/v2/pages/DomainV2Page'));
const SkillPage = loadOnRoute(() => import('bundles/browse/v2/pages/SkillPage'));

/* eslint-disable new-cap */
/* eslint-disable @babel/new-cap */

export default (
  <CourseraRoute
    path="/"
    component={BrowseApp}
    handle={{
      tracking: {
        data: () => {
          return {
            page: {
              segment: 'consumer',
              type: 'browse',
            },
          };
        },
      },
    }}
  >
    <Route path="browse" getComponent={AllDomainV2Page} />

    <Route path="browse/:domainSlug" getComponent={DomainV2Page} />
    <Route
      path="browse/:domainSlug/:subdomainSlug"
      getComponent={(...args) => {
        const [nextState] = args;
        const { subdomainSlug } = nextState.params;

        if (subdomainSlug && isSubdomainAndSkill(subdomainSlug) && isBrowseSkillsEnabled()) {
          SkillPage(...args);
        } else {
          DomainPage(...args);
        }
      }}
    />
    <Route path="/*" component={NotFound} />
  </CourseraRoute>
);
